<template>
  <div v-if="loadingList">
    <AppSkeletonTable></AppSkeletonTable>
  </div>
  <div v-else>
    <DataTable :value="results" responsiveLayout="stack">
      <Column
        header="ID"
        field="id"
        :sortable="true"
        headerStyle="width: 70px"
      />
      <Column
        header="Tarefa"
        field="description"
        :sortable="true"
        headerStyle="width: 300px"
      >
        <template #body="{ data }">
          {{ data.description }} - {{ data.itemCount }} itens
        </template>
      </Column>
      <Column
        header="Iniciado por"
        field="description"
        :sortable="true"
        headerStyle="width: 150px"
      >
        <template #body="{ data }">
          {{ data.createdBy?.name || '-' }}
        </template>
      </Column>
      <Column
        header="Início"
        field="createdAt"
        :sortable="true"
        headerStyle="width: 150px"
      >
        <template #body="{ data }">
          {{ $dayjs(data.createdAt).format('DD/MM/YYYY HH:mm') }}
        </template>
      </Column>
      <Column
        header="Fim"
        field="finishedAt"
        :sortable="true"
        headerStyle="width: 150px"
      >
        <template #body="{ data }">
          {{
            data.finishedAt
              ? $dayjs(data.finishedAt).format('DD/MM/YYYY HH:mm')
              : '-'
          }}
        </template>
      </Column>
      <Column header="Progesso" headerStyle="width: 150px">
        <template #body="{ data }">
          <ProgressBar :value="getProgress(data)" />
        </template>
      </Column>
    </DataTable>
    <Paginator
      :first="query.pageSize * pagination.current - 1"
      :rows="query.pageSize"
      :totalRecords="pagination.total"
      @page="changeListPage({ page: $event.page + 1 })"
    ></Paginator>
  </div>
</template>

<script>
import ProgressBar from 'primevue/progressbar';
import useApiList from '../../lib/useApiList';
import { JobApi } from '../../services/api';

let timer = null;

export default {
  name: 'JobList',
  components: {
    ProgressBar,
  },
  setup() {
    return useApiList(JobApi, { include: '[stats]' });
  },
  async created() {
    await this.fetchList();
    timer = setInterval(async () => {
      const { results, pagination } = await JobApi.fetch(this.query);
      this.results = results;
      this.pagination = pagination;
    }, 5 * 1000);
  },
  beforeUnmount() {
    clearInterval(timer);
  },
  methods: {
    getProgress(data) {
      const progress = Math.round((data.doneCount / data.itemCount) * 100);
      return progress < 100 ? progress : 100;
    },
  },
};
</script>

<style>
</style>